import { T2 } from 'ia-react-core';
import styled from 'styled-components';

export const StyledT = styled(T2)`
  margin-bottom: 39px;
`;
